/**
 * TicketTemplateVariant — the closed set of code-level ticket-rendering
 * layouts a fork may choose: `editorial`, `stencil`, or `strata`. There is
 * no `TicketTemplate` Firestore entity or catalog — the variant name IS the
 * template's identity. An event and a ticket type each store their own
 * chosen variant directly (`event.entity.ts` / `ticket-type.entity.ts`'s
 * `templateVariant` field); `resolveTicketTemplateVariant` beside
 * `resolveSalesWindow` in `ticket-type.entity.ts` resolves which one a
 * type's tickets actually render under.
 */
import { z } from "zod";

// The closed set of code-level renderers a fork may point at — a fourth
// value is an explicit amendment to this enum, never an open "any future
// variant" clause.
export const TicketTemplateVariantSchema = z.enum([
	"editorial",
	"stencil",
	"strata",
]);
export type TicketTemplateVariant = z.infer<typeof TicketTemplateVariantSchema>;

// The package's first-shipped variant — resolveTicketTemplateVariant's
// (ticket-type.entity.ts, beside resolveSalesWindow) terminal fallback when
// neither the ticket type nor the event names a variant. Never a literal
// repeated at the call site.
export const DEFAULT_TICKET_TEMPLATE_VARIANT: TicketTemplateVariant =
	"editorial";
